import React, {createContext, useReducer} from 'react'

export const SET_HARNESS_LIST = 'SET_HARNESS_LIST'
export const SELECT_HARNESS = 'SELECT_HARNESS'
export const SET_SHOW_HARNESS_POPUP = 'SET_SHOW_HARNESS_POPUP'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_HARNESS_LIST:
      return { ...data, harness_list: payload.data }
    case SELECT_HARNESS:
      return {
        ...data,
        selected_harness: payload.data.selected_harness,
        show_harness_popup: payload.data.show_harness_popup,
      }
    case SET_SHOW_HARNESS_POPUP:
      return {
        ...data,
        show_harness_popup: payload.data,
        selected_harness: payload.data ? data.selected_harness : {},
      }
    default:
      return data
  }
}

const initialState = {
  harness_list: [],
  selected_harness: {},
  show_harness_popup: false,
}

const HarnessStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <HarnessContext.Provider value={[state, dispatch]}>
      {children}
    </HarnessContext.Provider>
  )
}

export const HarnessContext = createContext(initialState)
export default HarnessStore
